'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import EarlyAccessHero from './components/EarlyAccessHero';
import EarlyAccessForm from './components/EarlyAccessForm';
import EarlyAccessInfo from './components/EarlyAccessInfo';

export default function EarlyAccessPage() {
    return (
        <main className="min-h-screen overflow-x-hidden" style={{ background: '#FAFAFA', color: '#0D0D0D' }}>
            <Header />
            <EarlyAccessHero />

            {/* Divider */}
            <div className="h-px bg-gray-200" />

            <div className="py-16 px-6 md:px-10 border-border">
                <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-16">
                    <div className="lg:col-span-7">
                        <EarlyAccessForm />
                    </div>
                    <div className="lg:col-span-5">
                        <EarlyAccessInfo />
                    </div>
                </div>
            </div>
            <Footer />
        </main>
    );
}